module.exports = __webpack_public_path__ + "static/img_1637-ce1a104cef667390fa5aa0be4a195f9b.webp";